/*
 * Selman Gold – product page
 *   <sg-gallery>   thumbnails [data-media-target] show the matching slide [data-media] in the stage
 *   form.product__form   option selects [data-option-index] → variant (JSON in script[data-product-json]):
 *                  updates hidden [data-variant-id], [data-price], [data-availability], add button, ?variant= URL.
 *                  Submit adds to the cart via /cart/add.js; without JS the form posts normally (→ cart page).
 *                  Live-price products ([data-price][data-sg-live]): the price follows window.SGRates and the hidden
 *                  properties _artiva_variant_ref {"variant id": [1, price]} + _live_price carry it to the cart –
 *                  the aurex cart transform charges that price in cart and checkout.
 */
(function () {
  'use strict';

  var locale = (window.SG && window.SG.locale) || 'de-DE';
  function money(cents) {
    return (cents / 100).toLocaleString(locale, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }

  if (!customElements.get('sg-gallery')) {
    customElements.define('sg-gallery', class extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          var thumb = e.target.closest('[data-media-target]');
          if (!thumb) return;
          var id = thumb.getAttribute('data-media-target');
          this.querySelectorAll('[data-media]').forEach(function (slide) {
            var on = slide.getAttribute('data-media') === id;
            slide.hidden = !on;
            if (!on) slide.querySelectorAll('video').forEach(function (v) { v.pause(); });
          });
          this.querySelectorAll('[data-media-target]').forEach(function (t) {
            var on = t === thumb;
            t.classList.toggle('is-active', on);
            t.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
        });
      }
    });
  }

  function initForm(form) {
    var root = form.closest('[data-section]');
    if (!root) return;
    var json = document.querySelector('script[data-product-json="' + root.getAttribute('data-section') + '"]');
    var variants = json ? JSON.parse(json.textContent) : [];
    var idInput = form.querySelector('[data-variant-id]');
    var button = form.querySelector('[data-add-button]');
    var note = form.querySelector('[data-cart-note]');
    var price = root.querySelector('[data-price]');
    var availability = root.querySelector('[data-availability]');

    function current() {
      return variants.find(function (v) { return String(v.id) === idInput.value; });
    }

    var liveRef = form.querySelector('[data-sg-live-ref]');
    var liveValue = form.querySelector('[data-sg-live-value]');
    function syncLive() {
      if (!liveRef || !price || !window.SGRates) return;
      var value = window.SGRates.productPrice(price.getAttribute('data-sg-live'));
      var ref = {};
      if (value > 0) ref[idInput.value] = [1, Math.round(value * 100) / 100];
      liveRef.value = value > 0 ? JSON.stringify(ref) : '';
      if (liveValue) liveValue.value = value > 0 ? (Math.round(value * 100) / 100).toFixed(2) : '';
    }
    document.addEventListener('sg:rates', syncLive);
    syncLive();

    function render(variant) {
      var ok = variant && variant.available;
      button.disabled = !ok;
      button.textContent = ok ? button.getAttribute('data-label-add') : button.getAttribute('data-label-soldout');
      if (note) note.hidden = true;
      if (!variant) return;
      if (price && !price.hasAttribute('data-sg-live')) price.textContent = money(variant.price);
      syncLive();
      if (availability) {
        var unique = variant.unique;
        availability.textContent = availability.getAttribute(ok ? (unique ? 'data-label-unique' : 'data-label-available') : 'data-label-soldout');
        availability.classList.toggle('is-soldout', !ok);
      }
    }

    form.addEventListener('change', function (e) {
      if (!e.target.matches('[data-option-index]')) return;
      var chosen = Array.from(form.querySelectorAll('[data-option-index]')).map(function (s) { return s.value; });
      var variant = variants.find(function (v) { return v.options.every(function (o, i) { return o === chosen[i]; }); });
      if (variant) {
        idInput.value = variant.id;
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      render(variant);
    });

    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      button.disabled = true;
      syncLive();
      var body = new FormData(form);
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: body
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Fehler');
          button.textContent = button.getAttribute('data-label-added');
          if (note) note.hidden = false;
          document.dispatchEvent(new CustomEvent('sg:cart', { detail: res.data }));
          setTimeout(function () { render(current()); if (note) note.hidden = false; }, 2500);
        })
        .catch(function (err) {
          render(current());
          window.alert(err.message);
        });
    });
  }

  function init() { document.querySelectorAll('form.product__form').forEach(initForm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
